import { render } from "./WalletsView.vue?vue&type=template&id=015e92d4&scoped=true"
import script from "./WalletsView.vue?vue&type=script&lang=js"
export * from "./WalletsView.vue?vue&type=script&lang=js"

import "./WalletsView.vue?vue&type=style&index=0&id=015e92d4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-015e92d4"]])

export default __exports__